
import React, { useState, useEffect } from 'react';
import '../Maintenance-styles/modal.css';
import SelectorGroupModal from './SelectorGroupModal';  // Modal de Grupos
import SelectorHostModal from './SelectorHostModal';    // Modal de Hosts
import SelectorUserModal from './SelectorUserModal';    // Modal de Usuarios

const CreateEventModal = ({
  onClose,
  onCreate,
  maintenanceType,
  setMaintenanceType,
  groups,
  hosts,
  users,  // Lista de usuarios disponibles
}) => {
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [isHostModalOpen, setIsHostModalOpen] = useState(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);  // Estado del modal de usuarios

  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedHosts, setSelectedHosts] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);  // Usuarios seleccionados para notificación

  const openGroupModal = () => setIsGroupModalOpen(true);
  const openHostModal = () => setIsHostModalOpen(true);
  const openUserModal = () => setIsUserModalOpen(true);  // Abrir modal de usuarios

  const handleSelectGroup = (group) => {
    if (!selectedGroups.some((g) => g.groupid === group.groupid)) {
      setSelectedGroups([...selectedGroups, group]);
    }
  };

  const handleSelectHost = (host) => {
    if (!selectedHosts.some((h) => h.hostid === host.hostid)) {
      setSelectedHosts([...selectedHosts, host]);
    }
  };

  const handleSelectUser = (user) => {
    if (!selectedUsers.some((u) => u.user_id === user.user_id)) {
      setSelectedUsers([...selectedUsers, user]);
    }
  };

  const handleRemoveGroup = (group) => {
    setSelectedGroups(selectedGroups.filter((g) => g.groupid !== group.groupid));
  };

  const handleRemoveHost = (host) => {
    setSelectedHosts(selectedHosts.filter((h) => h.hostid !== host.hostid));
  };

  const handleRemoveUser = (user) => {
    setSelectedUsers(selectedUsers.filter((u) => u.user_id !== user.user_id));
  };

  useEffect(() => {
    // Limpiar los seleccionados al cambiar el tipo de mantenimiento
    setSelectedGroups([]);
    setSelectedHosts([]);
    setSelectedUsers([]);
  }, [maintenanceType]);

  const handleCreate = () => {
    const newEvent = {
      name: document.querySelector('#new-event-title').value,
      description: document.querySelector('#new-event-description').value,
      start_time: document.querySelector('#new-event-start').value,
      end_time: document.querySelector('#new-event-end').value,
      event_type: maintenanceType,
      groupids: selectedGroups.map((group) => group.groupid),
      hostids: selectedHosts.map((host) => host.hostid),
      userids: selectedUsers.map((user) => user.user_id),  // Usuarios seleccionados
    };

    onCreate(newEvent);  // Enviar evento al backend
  };

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal">
        <h2>Crear Nuevo Evento</h2>

        <label>Título del Evento</label>
        <input id="new-event-title" type="text" placeholder="Título" />

        <label>Descripción</label>
        <textarea id="new-event-description" placeholder="Descripción"></textarea>

        <label>Fecha de Inicio</label>
        <input id="new-event-start" type="datetime-local" />

        <label>Fecha de Fin</label>
        <input id="new-event-end" type="datetime-local" />

        <label>Tipo de Mantenimiento</label>
        <select
          value={maintenanceType}
          onChange={(e) => setMaintenanceType(e.target.value)}
        >
          <option value="">Seleccionar tipo</option>
          <option value="group">Grupal</option>
          <option value="host">Dispositivo</option>
        </select>

        {maintenanceType && (
          <>
            <button
              className="add-group-button"
              onClick={maintenanceType === 'group' ? openGroupModal : openHostModal}
            >
              {maintenanceType === 'group' ? 'Agregar Grupo' : 'Agregar Host'}
            </button>

            <div className="tag-container">
              {selectedGroups.map((group) => (
                <span key={group.groupid} className="tag">
                  {group.name}
                  <button
                    className="remove-tag"
                    onClick={() => handleRemoveGroup(group)}
                  >
                    &times;
                  </button>
                </span>
              ))}
              {selectedHosts.map((host) => (
                <span key={host.hostid} className="tag">
                  {host.hostname}
                  <button
                    className="remove-tag"
                    onClick={() => handleRemoveHost(host)}
                  >
                    &times;
                  </button>
                </span>
              ))}
            </div>
          </>
        )}

        <button className="add-user-button" onClick={openUserModal}>
          Agregar Usuarios
        </button>

        <div className="tag-container">
          {selectedUsers.map((user) => (
            <span key={user.user_id} className="tag">
              {user.name}
              <button
                className="remove-tag"
                onClick={() => handleRemoveUser(user)}
              >
                &times;
              </button>
            </span>
          ))}
        </div>
        <label>Alarma</label>
        <select >
            <option value="">Sin Alarma</option>
            <option value="group">Una hora antes</option>
            <option value="host">1 dia antes</option>
            <option value="group">2 dias antes</option>
            <option value="host">1 semana antes</option>
        </select>


        <div className="button-container">
          <button className="create-button" onClick={handleCreate}>
            Crear Evento
          </button>
          {/* <button className="cancel-button" onClick={onClose}>
            Cancelar
          </button> */}
        </div>

        {isGroupModalOpen && (
          <SelectorGroupModal
            groups={groups}
            onClose={() => setIsGroupModalOpen(false)}
            onSelectGroup={handleSelectGroup}
          />
        )}

        {isHostModalOpen && (
          <SelectorHostModal
            hosts={hosts}
            onClose={() => setIsHostModalOpen(false)}
            onSelectHost={handleSelectHost}
          />
        )}

        {isUserModalOpen && (
          <SelectorUserModal
            users={users}
            onClose={() => setIsUserModalOpen(false)}
            onSelectUser={handleSelectUser}
          />
        )}
      </div>
    </>
  );
};

export default CreateEventModal;








